import React from 'react';

// imported
import Home from './HomePage';
import About from './AboutPage';
import Experience from './ExperiencePage';
import Projects from './ProjectPage';
import Contact from './ContactPage';
import Layout from '../components/Layout';

export default function LandingPage() {
  return (
    <Layout>
      <div className="container">
        <Home />
        <About />
        <Experience />
        <Projects />
        <Contact />
      </div>
    </Layout>
  );
}
